import { HorizontalRule } from "@mui/icons-material";

export const DividerConfig = {
    type: 6,
    label: 'Séparation',
    icon: HorizontalRule,
    allowedBy: [2, 9],
    autoConfig: false,
}